<!-- 应用管理 -->
<template>
  <div class="application-manage">
    <div class="table-header">
      <a-form :layout="'horizontal'" class="page-search" :colon="true">
        <a-row :gutter="20">
          <a-col span="6">
            <a-form-item
              label="应用简称"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <SelectModule
                v-model="params.appId"
                apiType="getAllAppInfo"
                autoValue="id"
                autoLabel="appShortName"
              />
              <!-- <InputText
                placeholder="请输入"
                v-model="params.appShortName"
                allowClear
              /> -->
            </a-form-item>
          </a-col>
          <a-col span="6">
            <a-form-item
              label="系统名称"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <InputText
                placeholder="请输入"
                v-model="params.appName"
                allowClear
              />
            </a-form-item>
          </a-col>
          
          <a-col class="flag" span="6" :offset="6">
            <a-button @click="onReset"
              ><a-icon type="reload" style="color: #585d68" />重置</a-button
            >
            <a-button type="primary" @click="handleSearch"
              ><IconSvg iconData="search" />查询</a-button
            >
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-concent">
      <div class="concent-buts">
        <a-button type="primary" @click="handleTableRow(true)"
          ><a-icon type="plus" />新增</a-button
        >
      </div>
      <TableList
        :columns="columns"
        :tableData="tableData"
        :loading="loading"
        :pageInfo="pageBean"
        @getList="changePage"
      >
        <div slot="action" slot-scope="record" class="columns-action">
          <a-button type="link" @click="handleTableRow(true, record.scope)"
            >编辑</a-button
          >
          <a-button type="link" @click="showDeletConfirm(record.scope)"
            >删除</a-button
          >
        </div>
      </TableList>
    </div>

    <AddEdit
      :modalFlag="modalFlag"
      :modalData="modalData"
      @handleFlag="handleTableRow"
    />
  </div>
</template>

<script>
import InputText from "@/components/form/InputText"; // 输入框组件
import SelectModule from "@/components/form/SelectModule"; // 下拉组件
import TableList from "@/components/table/TableList"; // 表格组件
import LenovoSelectModule from "@/components/form/LenovoSelectModule"; // 联想下拉
import API from "@/api/application.js"; // 请求接口
import AddEdit from "./components/AddEdit.vue";

import "./index.less";

export default {
  components: {
    InputText,
    SelectModule,
    TableList,
    LenovoSelectModule,
    AddEdit,
  },
  computed: {
    columns() {
      const columns = [
        {
          title: "序号",
          dataIndex: "key",
          key: "key",
          width: 100,
          align: "center",
          fixed: "left",
          ellipsis: true,
          customRender: (text, row, index) => {
            return (
              (this.pageBean.pageNum - 1) * this.pageBean.pageSize + index + 1
            );
          },
        },
        {
          title: "应用简称",
          dataIndex: "appShortName",
          key: "appShortName",
          ellipsis: true,
          scopedSlots: { customRender: "appShortName" },
        },
        {
          title: "系统名称",
          dataIndex: "appName",
          key: "appName",
          ellipsis: true,
          scopedSlots: { customRender: "appName" },
        },
        {
          title: "访问地址",
          dataIndex: "appLoginUrl",
          key: "appLoginUrl",
          ellipsis: true,
          scopedSlots: { customRender: "appLoginUrl" },
        },
        {
          title: "登出地址",
          dataIndex: "appLogoutUrl",
          key: "appLogoutUrl",
          ellipsis: true,
          scopedSlots: { customRender: "appLogoutUrl" },
        },
        {
          title: "签名密钥",
          dataIndex: "signatureKey",
          key: "signatureKey",
          ellipsis: true,
          scopedSlots: { customRender: "signatureKey" },
        },
        {
          title: "加密密钥",
          dataIndex: "encryptionKey",
          key: "encryptionKey",
          ellipsis: true,
          scopedSlots: { customRender: "encryptionKey" },
        },
        {
          title: "appID",
          dataIndex: "appId",
          key: "appId",
          ellipsis: true,
          scopedSlots: { customRender: "appId" },
        },
        {
          title: "key",
          dataIndex: "appKey",
          key: "appKey",
          ellipsis: true,
          scopedSlots: { customRender: "appKey" },
        },
        {
          title: "排序",
          dataIndex: "sortValue",
          key: "sortValue",
          width: 50,
          ellipsis: true,
          scopedSlots: { customRender: "sortValue" },
        },
        {
          title: "操作",
          dataIndex: "actions",
          key: "actions",
          width: 140,
          align: "center",
          fixed: "right",
          scopedSlots: { customRender: "action" },
        },
      ];
      return columns;
    },
  },
  data() {
    return {
      loading: false, // 是否加载
      pageBean: {
        // 自定义分页
        pageNum: 1, // 当前页数
        pageSize: 10, // 每页条数
        total: 0, // 数据总数
      },
      params: {
        appId: "",
        appName: "",
      },
      tableData: [], // 列表数据
      formItemLayout: {
        labelCol: {
          span: 6,
        },
        wrapperCol: {
          span: 18,
        },
      },
      modalFlag: false, // 弹层状态
      modalData: {}, // 表格选中数据
    };
  },
  mounted() {
    this.handleSearch();
  },
  methods: {
    // 查询
    handleSearch() {
      this.getData(1);
    },
    // 获取列表数据
    getData(pageNum) {
      this.loading = true;
      let params = {
        data: {
          pageBean: {
            pageNum: pageNum,
            pageSize: this.pageBean.pageSize,
          },
          params: {
            ...this.params,
          },
        },
      };
      API.pageAppManageInfo(params, (callback) => {
        this.loading = false;
        let list = []; // 数据
        if (callback.status == "S" && callback.data) {
          const backData = callback.data;
          const pageBean = { ...this.pageBean };
          pageBean.total = backData.total || 0;
          pageBean.pageNum = pageNum || 1;
          this.pageBean = pageBean;

          if (Array.isArray(backData.list) && backData.list.length > 0) {
            backData.list.map((item, index) => {
              // item.key = item.id;
              item.key = index;
            });
            list = backData.list;
          }
          this.tableData = list;
        }
      });
    },
    // 分页事件
    changePage(page, filters, sorter) {
      this.pageBean.pageNum = page.current || 1;
      this.pageBean.pageSize = page.pageSize || 10;
      this.getData(this.pageBean.pageNum);
    },
    // 重置
    onReset() {
      this.params = {
        appId: "",
        appName: "",
      };
      this.handleSearch();
    },
    // 查看详情
    handleTableRow(flag, row, status) {
      this.modalFlag = flag;
      this.modalData = row || {};
      if (status == 'ok') {
        this.getData(1);
      }
    },
    // 删除
    showDeletConfirm(row) {
      let _this = this;
      this.$confirm({
        title: "是否确定删除当前的应用?",
        content: (h) => <div style=""></div>,
        onOk() {
          const params = {
            data: {
              params: {
                id: row.id,
              },
            },
          };
          API.deleteAppManageInfo(params, (callback) => {
            if (callback.status == "S") {
              _this.$message.destroy();
              _this.$message.success("删除成功");
              _this.handleSearch();
            }
          });
        },
        onCancel() {
          console.log("Cancel");
        },
        class: "test",
      });
    }
  },
};
</script>
